<template>
    <div class="dropdown">
        <div class="dropdown_selected_container">
            <button @click="dropdownToggle" @keyup="keyHandler" @keydown="scrollblocker" aria-label="Open Select"
                role="button" aria-haspopup="listbox" aria-expanded="false" aria-live="polite">
                <div v-if="selected == null">
                    <label>{{ placeholder }}</label>
                </div>
                <div v-else>
                    <label>{{ selected.label }}</label>
                </div>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                    <path fill="#fff" d="M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z" />
                </svg>
            </button>
        </div>
        <div class="dropdown_options_container">
            <ul id="options" role="listbox" aria-label="Select an option" aria-activedescendant=""
                style="display: none">
                <li id="reset" v-if="selected != null">
                    <a href="javascript:void(0);" @click="(event) => setSelected(null, event)"
                        role="option"><span>Reset</span></a>
                </li>
                <li v-for="(option, index) in options" :key="index" :id="option.label"
                    :aria-selected="[selected != null && selected.label == option.label]" :class="[
                        selected != null && selected.label == option.label
                            ? 'selected_option'
                            : '',
                    ]">
                    <a href="javascript:void(0);" tabindex="-1" @click="(event) => setSelected(index, event)"
                        role="option"><span>{{
                                option.label
                        }}</span></a>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        placeholder: String,
        selected: Object,
        options: Array,
    },
    emits: ["setSelected"],
    setup(props, ctx) {
        function setSelected(index, event) {
            var listbox
            if (index != null) {
                ctx.emit("setSelected", props.options[index]);
                listbox = event.target.closest('#options')
                listbox.setAttribute('aria-activedescendant', props.options[index].label);
            } else {
                ctx.emit("setSelected", null);
                listbox = event.target.closest('#options')
                listbox.setAttribute('aria-activedescendant', '');
            }
        }

        function dropdownToggle(el) {
            let button = el.currentTarget;
            let parent = el.currentTarget.closest(".dropdown");
            let list = parent.querySelectorAll("ul")[0];

            if (list.style.display == "none") {
                button.setAttribute("aria-expanded", true);
                list.style.display = "block";
                clickOutsideEvent(list, el.currentTarget);
            } else {
                button.setAttribute("aria-expanded", false);
                list.style.display = "none";
                //document.removeEventListener("click", handler);
            }
        }

        function clickOutsideEvent(target, button) {
            var arg = {
                tgt: target,
                btn: button,
            };
            const event_handler = (event, arg) => {
                var target = arg.tgt;
                var button = arg.btn;

                var withinBoundariesOfDrop = event.composedPath().includes(target);
                var withinBoundariesOfButton = event.composedPath().includes(button);

                if (withinBoundariesOfDrop || withinBoundariesOfButton) {
                    //Click happened inside element
                } else {
                    target.style.display = "none";
                    document.removeEventListener("click", event_handler);
                }
            };
            document.addEventListener("click", (event) => event_handler(event, arg));
        }

        function keyHandler(e) {
            var currentIndex = null
            var parent;
            var listbox;

            switch (e.code) {
                case "ArrowDown":
                    e.preventDefault();
                    if (props.selected == null) {
                        ctx.emit("setSelected", props.options[0]);
                        listbox = document.getElementById(props.options[0].label).closest('#options');
                        listbox.setAttribute('aria-activedescendant', props.options[0].label);
                    } else {
                        if (props.selected != null) {
                            currentIndex = props.options.findIndex(x => x.label == props.selected.label);
                            if (currentIndex != props.options.length - 1) {
                                currentIndex = currentIndex + 1;
                                ctx.emit("setSelected", props.options[currentIndex]);
                                listbox = document.getElementById(props.options[currentIndex].label).closest('#options');
                                listbox.setAttribute('aria-activedescendant', props.options[currentIndex].label);
                            }
                        }
                    }
                    break;
                case "ArrowUp":
                    // code block
                    e.preventDefault();
                    if (props.selected == null) {
                        ctx.emit("setSelected", props.options[0]);
                        listbox = document.getElementById(props.options[0].label).closest('#options');
                        listbox.setAttribute('aria-activedescendant', props.options[0].label);
                    } else {
                        if (props.selected != null) {
                            currentIndex = props.options.findIndex(x => x.label == props.selected.label);
                            if (currentIndex > 0) {
                                currentIndex = currentIndex - 1;
                                ctx.emit("setSelected", props.options[currentIndex]);
                                listbox = document.getElementById(props.options[currentIndex].label).closest('#options');
                                listbox.setAttribute('aria-activedescendant', props.options[currentIndex].label);
                            }
                        }
                    }

                    break;
                case "Space":
                    // code block
                    parent = e.target.closest('.dropdown');
                    listbox = parent.querySelectorAll('ul')[0];
                    if (listbox.style.display == 'none') {
                        listbox.style.display = 'block';
                    } else {
                        listbox.style.display = 'none';
                    }
                    break;
                case "Backspace":
                    // code block
                    e.preventDefault();
                    if (props.selected != null) {
                        currentIndex = props.options.findIndex(x => x.label == props.selected.label);
                        ctx.emit("setSelected", null);
                        listbox = document.getElementById(props.options[currentIndex].label).closest('#options');
                        listbox.setAttribute('aria-activedescendant', null);
                    }
                    break;
                default:
                // code block
            }
        }

        function scrollblocker(e) {
            switch (e.code) {
                case "ArrowUp": case "ArrowDown": case "ArrowLeft": case "ArrowRight":
                case "Space": e.preventDefault(); break;
                default: break; // do not block other keys
            }
        }

        return {
            dropdownToggle,
            setSelected,
            keyHandler,
            scrollblocker
        };
    },
};
</script>

<style scoped>
/* ************************************************************************************************************************************** */
.selected_option {
    background-color: #c80959;
}

.selected_option a {
    color: #fff !important;
}

.wrapper,
.dropdown {
    display: flex;
    width: 100%;
}

.dropdown .dropdown_options_container,
.dropdown .dropdown_selected_container,
.dropdown ul {
    margin: 0px;
    padding: 0px;
}

.dropdown .dropdown_selected_container button div {
    cursor: pointer;
    display: block;
    padding: 5px;
    white-space: nowrap;
}

.dropdown .dropdown_selected_container button div label,
.dropdown .dropdown_selected_container button svg {
    cursor: pointer;
}

.dropdown .dropdown_selected_container button div:first-child {
    flex: 1 1 90%;
    width: 100%;
    text-align: left;
    font-size: 1.2em;
    padding: 8px 0px 8px 10px;
}

.dropdown .dropdown_selected_container button svg {
    flex: 1 1 10%;
    background-color: #c80959;
}

.dropdown .dropdown_selected_container button div {
    padding: 0;
    display: flex;
    align-items: center;
}

.dropdown .dropdown_options_container {
    position: relative;
}

.dropdown a,
.dropdown a:visited {
    color: #000;
    text-decoration: none;
    outline: none;
}

.dropdown a:hover {
    color: #5d4617;
}

.dropdown .dropdown_selected_container button:hover,
.dropdown .dropdown_selected_container button:focus {
    color: #5d4617;
}

.dropdown .dropdown_selected_container button {
    display: flex;
    flex-direction: row;
    background: #fff;
    overflow: hidden;
    border: 1px solid #868686;
    width: 100%;
    padding: 0px;
    align-items: stretch;
}

.dropdown .dropdown_options_container ul {
    background: #fff;
    color: #000;
    display: none;
    left: 0px;
    padding: 5px 0px;
    position: absolute;
    width: 100%;
    border: 1px solid #868686;
    list-style: none;
    max-height: 170px;
    overflow-y: scroll;
    top: 2px;
    z-index: 2;
    box-sizing: border-box;
}

li a {
    font-size: 13px;
}

li a span:nth-child(2) {
    line-height: 2em;
}

.dropdown .dropdown_options_container ul::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 1px rgba(0, 0, 0, 0.3);
    border-left: 1px solid rgba(0, 0, 0, 0.1);
}

.dropdown .dropdown_options_container ul::-webkit-scrollbar-thumb {
    background: rgba(0, 0, 0, 0.4);
}

.dropdown .dropdown_options_container ul::-webkit-scrollbar-thumb:window-inactive {
    background: #c80959;
}

.dropdown div.value {
    display: none;
}

.dropdown .dropdown_options_container ul li a {
    padding: 5px;
    display: block;
    font-size: 0.8em !important;
}

.dropdown .dropdown_options_container ul li a:hover {
    background-color: rgba(0, 0, 0, 0.05);
}

.dropdown {
    display: inline-block;
    width: 100%;
    margin: 0px;
}

.dropdown span:nth-child(3) {
    color: rgba(0, 0, 0, 0.4);
}

.dropdown>span:nth-child(2) {
    overflow: hidden;
    white-space: nowrap;
    display: inline-block;
}

.dropdown .dropdown_selected_container div:nth-child(2) {
    color: rgba(0, 0, 0, 0.6);
    font-size: 14px;
    font-weight: bold;
    line-height: 1.6em;
    background: #aa3f27;
    color: #fff;
}

.dropdown .dropdown_selected_container div:nth-child(3) {
    display: none;
}

/* Focus handlers */
.selected {
    color: #5d4617;
}

.dropdown .dropdown_selected_container button:focus {
    outline: 1px solid black;
}

.dropdown .dropdown_options_container ul li button:focus {
    outline: 1px solid black;
}
</style>
